import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'

const StyledInput = styled.input<{ error?: boolean; fontSize?: string; align?: string }>`
  color: ${({ error, theme }) => (error ? theme.colors.failure : theme.colors.text)};
  width: 0;
  position: relative;
  font-weight: 500;
  outline: none;
  border: none;
  flex: 1 1 auto;
  font-size: 13px;
  text-align: ${({ align }) => align && align};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 2px 0.5rem;
  -webkit-appearance: textfield;
  border-radius: 16px;
  background-color: #e9eaeb;

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  [type='number'] {
    -moz-appearance: textfield;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ::placeholder {
    color: ${({ theme }) => theme.colors.textSubtle};
  }
`
export const Input = React.memo(function InnerInput({
  value,
  onUserInput,
  placeholder,
  ...rest
}: {
  value: string | number
  onUserInput: (input: string) => void
  error?: boolean
  fontSize?: string
  align?: 'right' | 'left'
} & Omit<React.HTMLProps<HTMLInputElement>, 'ref' | 'onChange' | 'as'>) {
  const { t } = useTranslation()
  return (
    <StyledInput
      {...rest}
      value={value}
      onChange={(event) => {
        onUserInput(event.target.value)
      }}
      // universal input options
      inputMode="text"
      title={t('Address')}
      autoComplete="off"
      autoCorrect="off"
      // text-specific options
      type="text"
      pattern="^(0x[a-fA-F0-9]{40})$"
      placeholder={placeholder || '0x'}
      minLength={1}
      maxLength={79}
      spellCheck="false"
    />
  )
})

export default Input
